var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 225,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99644531 0.83273438 1.99289063 1.66546875 3.01953125 2.5234375 C23.9360052 20.57441149 38.7885585 47.19433132 41 75 C41.95265553 95.71698254 40.31801412 113.94906444 32 133 C31.5975708 133.92256592 31.5975708 133.92256592 31.18701172 134.86376953 C19.39072736 161.28716412 -3.31695777 182.35366036 -30.13671875 192.93164062 C-57.95774237 203.35033008 -89.80406429 203.34862061 -117 191 C-117.97839844 190.57074219 -118.95679687 190.14148438 -119.96484375 189.69921875 C-146.80096262 177.18039851 -166.84804657 154.37231576 -177.62890625 127.015625 C-178.91745535 123.36922338 -180.01215484 119.73855221 -181 116 C-181.31710938 114.81019531 -181.63421875 113.62039062 -181.9609375 112.39453125 C-185.86715388 95.10325234 -185.5634962 76.12238616 -181 59 C-180.68289062 57.79988281 -180.36578125 56.59976563 -180.0390625 55.36328125 C-175.63779895 40.67679544 -168.3218096 26.38045674 -158 15 C-157.31550781 14.18660156 -156.63101563 13.37320313 -155.92578125 12.53515625 C-146.47158949 1.51941038 -135.76789943 -6.38013725 -123 -13 C-121.96230469 -13.54527344 -120.92460938 -14.09054687 -119.85546875 -14.65234375 C-81.42513044 -33.64998269 -32.74752371 -27.43107716 0 0 Z M-97 -8 C-98.21816406 -7.67128906 -99.43632813 -7.34257812 -100.69140625 -7.00390625 C-125.96435806 0.61223877 -146.21638712 18.02925149 -159 41 C-171.49497114 65.49014343 -173.27800498 92.93264198 -165.36669922 119.09423828 C-156.89166476 144.73518522 -138.74997227 164.20727575 -114.9375 176.375 C-108.17109598 179.68361428 -101.33097999 182.21424846 -94 184 C-93.09765625 184.22429687 -92.1953125 184.44859375 -91.265625 184.6796875 C-66.5036398 189.78597258 -39.21704152 184.70712466 -18 171 C5.59395876 154.39053444 20.4171798 132.94002677 26.25 104.5 C29.9589408 79.23910591 25.10254854 52.79930877 10.3828125 31.6796875 C8.65268268 29.39145129 6.8510299 27.19140524 5 25 C4.35546875 24.20980469 3.7109375 23.41960938 3.046875 22.60546875 C-12.12249356 4.76741498 -34.24721041 -7.45245936 -57.51953125 -10.71875 C-70.96193026 -11.80500447 -83.93588383 -11.56556541 -97 -8 Z ",
    fill: "#4F4F4F",
    transform: "translate(184,25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C0.60714844 2.2578125 1.21429688 2.515625 1.83984375 2.78125 C6.79399118 5.57635669 9.03923363 11.56403231 10.8125 16.75 C12 22 12 22 12 34 C-3.51 34 -19.02 34 -35 34 C-32.95578402 44.75390281 -32.95578402 44.75390281 -27 52 C-21.6924709 54.75253991 -17.55759032 55.45669259 -11.625 55.3125 C-10.8812915 55.30412109 -10.13758301 55.29574219 -9.37133789 55.28710938 C-4.02453224 55.17027761 0.84826518 54.49868649 6 53 C6.66 55.97 7.32 58.94 8 62 C-1.86086068 67.70891934 -13.73001046 68.43275654 -24.6875 65.875 C-33.1650097 63.29909477 -39.93144849 57.69133371 -44.15625 49.85546875 C-49.13197088 38.85557151 -49.01872176 27.29348815 -45 16 C-41.28653465 8.41161429 -35.16706723 1.72982059 -27.4375 -1.875 C-18.05698803 -4.94498574 -9.02426962 -3.91712802 0 0 Z M-30.50390625 11.80078125 C-33.71437304 16.5112952 -34.12778264 18.89447847 -35 25 C-23.78 25 -12.56 25 -1 25 C-1 18.31001582 -1.1988474 15.19979628 -5 10 C-8.53812818 6.64957093 -12.20438838 5.73322123 -17 5.5 C-22.8085996 5.78205643 -26.74294922 7.29740154 -30.50390625 11.80078125 Z ",
    fill: "#505050",
    transform: "translate(97,81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.82320599 -0.67064241 9.19631117 -0.90263699 14 0 C17.71852421 3.04895072 19.70431197 6.82243894 22 11 C22.74449396 12.21334711 23.49733466 13.42160649 24.2578125 14.625 C26.21491354 17.72479552 28.11897698 20.85328862 30 24 C30.56714722 23.12263184 30.56714722 23.12263184 31.14575195 22.22753906 C32.86651139 19.56739217 34.58948202 16.9086845 36.3125 14.25 C36.90740234 13.32960938 37.50230469 12.40921875 38.11523438 11.4609375 C38.69208984 10.57148437 39.26894531 9.68203125 39.86328125 8.765625 C40.39219971 7.94868164 40.92111816 7.13173828 41.46606445 6.29003906 C41.97226318 5.53432617 42.47846191 4.77861328 43 4 C43.49048828 3.24976562 43.98097656 2.49953125 44.48632812 1.7265625 C46 0 46 0 49.35546875 -0.390625 C50.62003906 -0.34421875 51.88460937 -0.2978125 53.1875 -0.25 C55.09595703 -0.19585937 55.09595703 -0.19585937 57.04296875 -0.140625 C58.01878906 -0.09421875 58.99460938 -0.0478125 60 0 C55.21222365 7.90418351 49.92160866 15.36697901 44.44458008 22.80419922 C43.89954834 23.54814941 43.3545166 24.29209961 42.79296875 25.05859375 C42.3033667 25.72173584 41.81376465 26.38487793 41.30932617 27.06811523 C40.01218137 28.98202663 38.98361977 30.91028075 38 33 C39.38871255 35.03288412 40.77777582 37.06552738 42.16723633 39.09790039 C43.3511787 40.82981003 44.53460655 42.56207151 45.7175293 44.29467773 C48.41381151 48.23964048 51.11549707 52.17936201 53.8671875 56.0859375 C54.28492432 56.68059814 54.70266113 57.27525879 55.13305664 57.88793945 C56.24789855 59.47077958 57.36793268 61.04995899 58.48828125 62.62890625 C60 65 60 65 60 67 C55.06024324 67.96090369 50.90561391 68.24935074 46 67 C41.93372551 63.55585268 39.50558386 58.58935364 37.04003906 53.94580078 C35.59794616 51.24780068 33.98415965 48.66335106 32.375 46.0625 C31.57930443 44.71069675 30.78579918 43.35757988 30 42 C26.52988514 46.11421971 23.736391 50.48440393 20.9375 55.0625 C19.66737734 57.13281881 18.39408801 59.19950965 17.09448242 61.25146484 C16.22697331 62.6373895 15.40894539 64.05426876 14.609375 65.48046875 C13 67 13 67 9.86328125 67.390625 C8.69152344 67.34421875 7.51976563 67.2978125 6.3125 67.25 C5.13300781 67.21390625 3.95351562 67.1778125 2.73828125 67.140625 C1.83464844 67.09421875 0.93101563 67.0478125 0 67 C0.63185636 63.2740577 2.29145282 60.85125968 4.45703125 57.7890625 C5.15763672 56.79132813 5.85824219 55.79359375 6.58007812 54.765625 C7.31677734 53.72921875 8.05347656 52.6928125 8.8125 51.625 C10.93844354 48.60899477 13.06334102 45.59232619 15.18212891 42.57128906 C16.25013837 41.06064232 17.3304981 39.55836392 18.43896484 38.07714844 C20.54022142 35.34966521 20.54022142 35.34966521 20.72583008 32.05688477 C19.97893159 29.94029555 19.10074882 28.39898188 17.8125 26.56640625 C17.36495361 25.92324463 16.91740723 25.28008301 16.45629883 24.61743164 C15.97572021 23.9393042 15.4951416 23.26117676 15 22.5625 C14.51104248 21.86181396 14.02208496 21.16112793 13.51831055 20.43920898 C12.01727395 18.28920697 10.50893741 16.14446168 9 14 C7.66735529 12.09608904 6.33696035 10.1906728 5.00976562 8.28295898 C3.87055579 6.6459256 2.72642361 5.01232092 1.58203125 3.37890625 C0 1 0 1 0 0 Z ",
    fill: "#525252",
    transform: "translate(115,79)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.495 1.98 2.495 1.98 3 4 C4.32 3.01 5.64 2.02 7 1 C11.21260199 2.48948834 12.30459703 4.88696193 14.1875 8.8125 C14.69667969 9.85019531 15.20585938 10.88789062 15.73046875 11.95703125 C18.63191861 18.91158337 18 24.07975059 18 32 C2.49 32 -13.02 32 -29 32 C-29.33 33.32 -29.66 34.64 -30 36 C-30 34.35 -30 32.7 -30 31 C-17.46 30.67 -4.92 30.34 8 30 C7.67 28.35 7.34 26.7 7 25 C7 24.01 7 23.02 7 22 C6.01 22.495 6.01 22.495 5 23 C4.89042969 22.33613281 4.78085938 21.67226562 4.66796875 20.98828125 C3.44355007 14.06365659 3.44355007 14.06365659 0 8 C-0.66 7.67 -1.32 7.34 -2 7 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#5C5C5C",
    transform: "translate(91,83)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.62 0 9.24 0 14 0 C9.90596171 6.55046126 5.75982648 12.91509362 1 19 C-0.18429132 15.44712603 0.00815769 13.58589143 1 10 C3 8.8125 3 8.8125 5 8 C5.33 7.01 5.66 6.02 6 5 C4.68 5 3.36 5 2 5 C2.33 4.01 2.66 3.02 3 2 C2.01 1.34 1.02 0.68 0 0 Z ",
    fill: "#5C5C5C",
    transform: "translate(161,79)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.66 4.62 1.32 7 2 C7 2.66 7 3.32 7 4 C7.66 4.33 8.32 4.66 9 5 C7.625 6.5 7.625 6.5 6 8 C5.34 8 4.68 8 4 8 C3.67 6.68 3.34 5.36 3 4 C2.34 4 1.68 4 1 4 C0.34 5.98 -0.32 7.96 -1 10 C-2.32 9.67 -3.64 9.34 -5 9 C-5 8.34 -5 7.68 -5 7 C-4.01 6.67 -3.02 6.34 -2 6 C-0.77479736 2.99152582 -0.77479736 2.99152582 0 0 Z ",
    fill: "#5A5A5A",
    transform: "translate(90,79)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 -0.125 6.0625 C-2.19821268 9.31053319 -3.35433814 10.01468598 -7 11 C-7.33 10.01 -7.66 9.02 -8 8 C-5.36 5.36 -2.72 2.72 0 0 Z ",
    fill: "#5C5C5C",
    transform: "translate(37,28)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C1.195625 3.45375 0.39125 3.9075 -0.4375 4.375 C-3.08856572 5.74725665 -3.08856572 5.74725665 -4 8 C-6.32156597 8.40729228 -8.6568787 8.74438677 -11 9 C-9.948125 8.1646875 -9.948125 8.1646875 -8.875 7.3125 C-5.88655739 4.90875268 -2.94059762 2.46189568 0 0 Z ",
    fill: "#5A5A5A",
    transform: "translate(178,186)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.495 1.98 0.495 4 1 C3.67 2.98 3.34 4.96 3 7 C1.68 6.34 0.36 5.68 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#464646",
    transform: "translate(145,114)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C2.67 2.66 2.34 3.32 2 4 C-1 5 -1 5 -4 5 C-4 4.34 -4 3.68 -4 3 C-3.01 3 -2.02 3 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#474747",
    transform: "translate(36,184)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C7.33 1.99 7.66 2.98 8 4 C7.01 4.495 7.01 4.495 6 5 C3.98079663 3.69593116 1.98075027 2.36176581 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#666666",
    transform: "translate(167,30)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.66 2.31 3.32 4.62 4 7 C1 6 1 6 -0.25 4.0625 C-0.4975 3.381875 -0.745 2.70125 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#5E5E5E",
    transform: "translate(20,150)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.b6fdda2e91d33b5609160012e8bf3ffd.svg";
export { ForwardRef as ReactComponent };